import { Injectable } from '@angular/core'
import * as Msal from 'msal'
import { AppConfig } from '../config'

@Injectable()
export class MicrosoftSignInService {
  msalClient: Msal.UserAgentApplication

  constructor() {
    const config = {
      auth: {
        clientId: AppConfig.microsoftOAuthClientId,
        authority: 'https://login.microsoftonline.com/common',
      },
    }
    this.msalClient = new Msal.UserAgentApplication(config)
  }

  loginPopup() {
    const loginRequest = {
      scopes: ['openid', 'profile', 'email', 'User.Read'],
    }

    return this.msalClient.loginPopup(loginRequest)
  }

  loginRedirect() {
    const loginRequest = {
      scopes: ['openid', 'profile', 'email', 'User.Read'],
    }

    return this.msalClient.loginRedirect(loginRequest)
  }

  logout() {
    this.msalClient.logout()
  }
}



// WEBPACK FOOTER //
// ./src/services/microsoft-sign-in.ts